import React from 'react';

const CategoryTags = ({ tags }) => {
  return (
    <div style={{ marginTop: 5 }}>
      {tags.map((tag) => (
        <div className="tag_label" key={tag}>
          {tag}
        </div>
      ))}
    </div>
  );
};

export default CategoryTags;
